/**
 * The Planner list's last row (spec 2026-10-14 §5): a + in the circle column and "New to-do". It opens
 * the form for the picked day, in place of "+ Add" (the home card keeps its own).
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import Icon from 'react-native-vector-icons/Ionicons';
import { Text } from '@/components/common/text';
import { Hoverable } from '@/components/shared/redesign/Hoverable';
import { useThemedStyles } from '@/hooks/shared/useThemeColors';
import { useTypography } from '@/hooks/shared/useTypography';
import { useSpacing } from '@/hooks/shared/useSpacing';
import { CHECKBOX, ROW_PAD_LARGE } from './TodoRow';

/** The + glyph, a touch under the 24pt circle column it sits in. */
const PLUS_SIZE = 22;

export const NewTodoRow: React.FC<{ onPress: () => void }> = ({ onPress }) => {
  const type = useTypography();
  const space = useSpacing();
  const styles = useThemedStyles(({ colors }) =>
    StyleSheet.create({
      row: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: space.md,
        paddingVertical: ROW_PAD_LARGE,
      },
      plusSlot: {
        width: CHECKBOX,
        alignItems: 'center',
      },
      plus: {
        color: colors.text.quiet,
      },
      label: {
        ...type.bodyLarge,
        color: colors.text.quiet,
      },
    }),
  );
  return (
    <Hoverable
      hover="row"
      bleed={space.sm}
      style={styles.row}
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel="New to-do"
    >
      <View style={styles.plusSlot}>
        <Icon name="add" size={PLUS_SIZE} style={styles.plus} />
      </View>
      <Text style={styles.label}>New to-do</Text>
    </Hoverable>
  );
};

NewTodoRow.displayName = 'NewTodoRow';
